<template>
  <div class="success-page">
    <Card dis-hover class="success-card">
      <div class="success-icon">
        <Icon type="ios-checkmark-circle" />
      </div>
      <div class="success-title">提交成功</div>
      <div class="success-desc">信息已提交成功，无需重复填写。</div>
      <div v-if="$route.query.checkId || $route.query.code" class="success-desc">检查单号：{{ $route.query.checkId || $route.query.code }}</div>
      <div class="success-actions">
        <Button type="primary" long :loading="loading" @click="goHome">查看检测进展</Button>
        <Button long class="success-actions__secondary" @click="goToReport">查询报告</Button>
      </div>
    </Card>
  </div>
</template>

<script>
import { ensureH5Session, retainedQuery } from '../utils/session'
import { resolvePidEntry } from '../utils/entryRouting'
export default {
  name: 'SubmitSuccess',
  data () { return { loading: false } },
  methods: {
    async goHome () {
      if (this.loading) return
      this.loading = true
      try {
        await ensureH5Session(this)
        const pid = this.$route.query.checkId || this.$route.query.code
        const target = pid ? await resolvePidEntry(this.$http, pid) : null
        const path = target && target.path.indexOf('/projects/') === 0 ? target.path : (target && target.query.projectId ? '/projects/' + encodeURIComponent(target.query.projectId) : '/projects')
        await this.$router.replace({ path, query: retainedQuery({ serialNum: pid || '' }) })
      } catch (error) {
        this.$Message.warning('检测进展暂时无法加载，请稍后重试')
      } finally { this.loading = false }
    },
    goToReport () {
      this.$router.replace({
        path: '/report',
        query: this.$route.query
      })
    }
  }
}
</script>

<style scoped>
.success-page {
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 64px 16px 40px;
  box-sizing: border-box;
  background: var(--wpc-bg);
}

.success-card {
  width: 100%;
  max-width: 520px;
  border: 1px solid #edf0f4;
  border-radius: var(--wpc-radius);
  text-align: center;
  padding: 28px 12px;
  box-shadow: none;
}

.success-icon {
  font-size: 64px;
  line-height: 1;
  color: var(--wpc-primary);
}

.success-title {
  margin-top: 16px;
  font-size: 28px;
  font-weight: 600;
  color: #1f2d3d;
}

.success-desc {
  margin: 16px auto 0;
  max-width: 380px;
  color: #63738a;
  line-height: 1.8;
  font-size: 15px;
}

.success-actions {
  margin-top: 28px;
}

.success-actions__secondary {
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/SubmitSuccess.vue